import { CopyButton } from '@teach/ui'
import { useMessages, useUiLang } from '@/i18n'
import { claudeCodePrompt } from '../lib/claudeCodePrompt'
import { messages } from '../messages'

/** Команды в `обратных кавычках` подсвечиваем, как в терминале; сами кавычки
 *  остаются в копируемом тексте — Claude Code по ним видит, что выполнять. */
const Highlighted = ({ text }: { text: string }) => (
  <>
    {text.split(/(`[^`]+`)/).map((part, i) =>
      part.startsWith('`') ? (
        <span key={i} className="text-brand">
          {part}
        </span>
      ) : (
        part
      ),
    )}
  </>
)

/** Вкладка Claude Code: готовая просьба, которую автор копирует и отправляет в чат. */
export const ClaudeCodePromptCard = () => {
  const m = useMessages(messages)
  const prompt = claudeCodePrompt(useUiLang())
  return (
    <div className="space-y-3 rounded-2xl border border-foreground/10 bg-background/40 p-3">
      <div className="flex items-center justify-between gap-3 px-2 pt-1">
        <p className="text-base font-medium">{m.claudeCodeSend}</p>
        <CopyButton value={prompt} />
      </div>
      <pre className="whitespace-pre-wrap break-words rounded-xl bg-foreground/5 p-4 font-mono text-sm leading-relaxed text-muted-foreground">
        <Highlighted text={prompt} />
      </pre>
    </div>
  )
}
